import {CanActivateFn} from "@angular/router";
import {environment} from "../../../environments/environment";

export const supportListGuard: CanActivateFn = () => environment.support.enabled && environment.support.list;
